<template>
	<div class="c-script-results">
		<h3>Results</h3>
		<article
			v-if="!processing && generation && generation.result"
			class="article-text-sm"
		>
			<p>
				Your results can be accessed in the
				<router-link to="/generations">AI generations page.</router-link>
			</p>
		</article>
		<div class="c-script-results__loader" v-if="processing">
			<span class="c-spinner"></span>
			<small>
				Creating your script.. this usually takes less than a minute.
			</small>
		</div>
		<main v-if="!processing">
			<template v-if="generation && generation.result">
				<RenderScript :generation="generation"></RenderScript>
			</template>
			<div class="c-script-results__error" v-if="error">
				<h4>
					<svg
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M14.827 15.1716C13.2649 13.6095 10.7323 13.6095 9.17017 15.1716M9.25 9.5V9.49M14.75 9.5V9.49M18.3639 5.63604C21.8787 9.15076 21.8787 14.8492 18.3639 18.3639C14.8492 21.8787 9.15074 21.8787 5.63604 18.3639C2.12132 14.8492 2.12132 9.15074 5.63604 5.63604C9.15076 2.12132 14.8492 2.12132 18.3639 5.63604ZM9.5 9.5C9.5 9.77614 9.38807 10 9.25 10C9.11193 10 9 9.77614 9 9.5C9 9.22386 9.11193 9 9.25 9C9.38807 9 9.5 9.22386 9.5 9.5ZM15 9.5C15 9.77614 14.8881 10 14.75 10C14.6119 10 14.5 9.77614 14.5 9.5C14.5 9.22386 14.6119 9 14.75 9C14.8881 9 15 9.22386 15 9.5Z"
							stroke="currentColor"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
					</svg>
					<span> Error </span>
				</h4>

				<article>
					{{ error }}
				</article>
			</div>
		</main>
	</div>
</template>

<script>
import RenderScript from '@swipekit/components/utils/render-script.vue';

export default {
	components: {
		RenderScript,
	},

	data: function () {
		return {
			processing: true,
			generation: null,

			error: null,
		};
	},

	props: {
		form: {},
	},

	computed: {
		results: function () {
			return [
				{
					name: 'va-gen-01',
					script: this.form.script,
				},
			];
		},
	},

	methods: {
		next: function () {
			this.$emit('next');
		},
		async loader(form) {
			this.processing = true;

			const maxTime = 120000; // 120 seconds
			const interval = 2000; // 2 seconds
			const start = Date.now();

			const poll = async () => {
				const generation = await this.$store.dispatch(
					'briefs/getGeneration',
					this.form.id
				);

				if (generation.status !== 'PROCESSING') {
					return generation; // Done
				}

				// Stop polling after 120 seconds
				if (Date.now() - start >= maxTime) {
					throw new Error('Generation timed out');
				}

				// Wait 2 seconds and try again
				await new Promise((resolve) => setTimeout(resolve, interval));
				return poll();
			};

			try {
				const generation = await poll();
				if (generation) {
					// also refresh workspace, but no need to await it
					this.$store.dispatch('workspaces/refresh');
				}
				this.generation = generation;
			} catch (err) {
				console.log(err);
			}

			this.processing = false;
		},
		async createGeneration() {
			if (this.form.generationId) {
				return await this.loader();
			} else {
				// create the generation
				let generation = null;
				try {
					generation = await this.$store.dispatch(
						'briefs/generateScript',
						this.form
					);
					this.form.id = generation.id;
				} catch (err) {
					if (err.response && err.response.data) {
						this.error = err.response.data;
					} else {
						this.error = `Something went wrong on our side. Credits won't be deducted for this error.`;
					}
				}

				this.processing = false;

				if (generation) {
					return await this.loader();
				}
			}
		},
	},

	mounted: function () {
		this.createGeneration();
	},
};
</script>

<style lang="scss">
.c-script-results {
	margin: 0 auto;
	width: var(--page-width);
	background-color: var(--color-bg-1);
	padding: 1rem;
	border-radius: 0.5rem;
	border: var(--color-bg-3) solid 1px;

	h3 {
		text-align: center;
		margin-bottom: 0.5rem;
	}

	> article {
		opacity: 0.8;
		text-align: center;
	}

	&__loader {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;

		.c-spinner {
			border-color: var(--color-primary);
			border-bottom-color: transparent;
		}
		small {
			margin-top: 0.5rem;
			display: block;
		}
	}

	&__error {
		max-width: 400px;
		margin: 0 auto;
		text-align: center;

		h4 {
			display: flex;
			align-items: center;
			justify-content: center;

			svg {
				margin-right: var(--margin);
			}
		}
	}
}
</style>
